import React from 'react'
import _ from 'lodash'
import formatJson from 'format-json'
import AceEditor from 'react-ace'
import styled from 'styled-components'
import { parseJsonSafe } from '@feedyou/utils'

import { toastNotifyInvalidJsonError } from '../lib/feedbotToast/generalImplementations'
import { OnFormDataChange } from './modals/hooks'

import 'ace-builds/src-noconflict/mode-json'
import 'ace-builds/src-noconflict/ext-searchbox' // Not sure if we need this
import 'ace-builds/src-noconflict/theme-tomorrow'

interface Props {
  editorValue?: object
  initialEditorValue?: object
  onChange?: OnFormDataChange
}

interface State {
  stringifiedValue?: string
}

export default class BotSettingsJsonEditor extends React.Component<Props, State> {
  static defaultProps = { editorValue: {} }
  state = { stringifiedValue: formatJson.plain(this.props.editorValue) }

  UNSAFE_componentWillReceiveProps(nextProps: Readonly<Props>) {
    if (nextProps.initialEditorValue !== this.props.initialEditorValue) {
      this.setState({ stringifiedValue: formatJson.plain(nextProps.initialEditorValue) })
    }
  }

  onChange = (editorValue: string) => {
    this.setState({ stringifiedValue: editorValue })
    const parsedValue = parseJsonSafe(editorValue)
    if (parsedValue) {
      this.props.onChange?.(parsedValue, false)
    }
  }

  format = () => {
    const parsedJson = parseJsonSafe(this.state.stringifiedValue)

    if (!_.isObject(parsedJson)) {
      toastNotifyInvalidJsonError()
      return false
    }

    this.setState({ stringifiedValue: formatJson.plain(parsedJson) })
  }

  // When this.state.stringifiedValue is invalid JSON, this.props.editorValue contains the last
  // valid value. Because of this, we cannot rely on this.props.editorValue when submitting
  // form, because it may be inconsistent with the UI state. For this reason, we need to get
  // value imperatively via this.getValue() whenever we want to submit.
  getValue = () => parseJsonSafe(this.state.stringifiedValue)

  render() {
    return (
      <StyledAceEditor
        mode="json"
        tabSize={2}
        theme="tomorrow"
        editorProps={{ $blockScrolling: Infinity }}
        value={this.state.stringifiedValue}
        onChange={this.onChange}
      />
    )
  }
}

const StyledAceEditor = styled(AceEditor)`
  width: 100% !important;
  height: 100% !important;
`
